import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  loading: false,
  error: null,
  configByTeamId: {},
};

const analyticTeamReportSlice = createSlice({
  name: 'analyticTeamReport',
  initialState,
  reducers: {
    setAnalyticTeamReportConfig: (state, action) => {
      const { teamId, config } = action.payload || {};
      state.configByTeamId[teamId] = config;
      state.loading = false;
      state.error = null;
    },
    deleteAnalyticTeamReportConfig: (state, action) => {
      const teamId = action.payload;
      delete state.configByTeamId[teamId];
      state.loading = false;
      state.error = null;
    },
    resetAnalyticTeamReportConfig: () => initialState
  },
});

export const {
  setAnalyticTeamReportConfig,
  deleteAnalyticTeamReportConfig,
  resetAnalyticTeamReportConfig,
} = analyticTeamReportSlice.actions;

// Selectors
export const selectAnalyticTeamReportConfig = (state) => state.analyticTeamReport.configByTeamId;

export default analyticTeamReportSlice.reducer;